// extracted by mini-css-extract-plugin
export default {"button":"AddDocumentsButton_button__0cDlj"};